import { AnalyticsInput, MetadataMomentMarketingInput } from '../../gql/graphql';
import { QueryParamKeys } from '../../constants/query-params';
import { getSystemName } from '../window/window.helpers';
import { detectPlatform } from '../deviceDetection';
import { getPersistedMetadataParams, MetadataParams } from '../params/metadataParams';
import { getQueryParam, parseEntrypoint } from '../params/params';

// Returns undefined when the visit carried no marketing params, so the payload omits `marketing`
// entirely rather than sending a block of nulls.
const buildMarketing = (params: MetadataParams): MetadataMomentMarketingInput | undefined => {
  const marketing: MetadataMomentMarketingInput = {
    id: params.utmId,
    source: params.utmSource,
    medium: params.utmMedium,
    campaign: params.utmCampaign,
    term: params.utmTerm,
    content: params.utmContent,
    adPlatform: params.adPlatform,
    adPlatformClickId: params.adClickId,
  };

  return Object.values(marketing).some(Boolean) ? marketing : undefined;
};

// Entrypoint and marketing both come from the same persisted metadata bundle
// (see resolveAndPersistMetadataParams) so buildAnalytics is the single source of truth and
// callers don't need to thread the entrypoint through machine context.
export const buildAnalytics = (): AnalyticsInput => {
  const params = getPersistedMetadataParams();
  const marketing = buildMarketing(params);

  return {
    campaignMedium: getQueryParam(QueryParamKeys.CampaignMedium) || undefined,
    campaignSource: getQueryParam(QueryParamKeys.CampaignSource) || undefined,
    metadataMoment: {
      entrypoint: parseEntrypoint(params.entrypoint),
      system: {
        name: getSystemName(),
        platform: detectPlatform(),
        version: import.meta.env.VITE_APP_VERSION,
      },
      ...(marketing && { marketing }),
    },
  };
};
